export class CorpusCorner {
  public constructor(
    public readonly ownedByLeftSection: boolean,
    public readonly ownedByRightSection: boolean,
  ) {}
}
